import Modal from "../UI/Modal";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { closeConfirmToggle } from "../../store/reducers/talentos/talentos.reducer";
import {
  toggleTalentoActiveThunk,
  getTalentosThunk,
} from "../../store/reducers/talentos/talentos.thunks";

const ConfirmToggleModal = () => {
  const dispatch = useDispatch();
  const { confirmModalOpen, toggleTalentoId, toggling, list, page, search } =
    useSelector((state) => state.talentos);

  const talento = list.find((t) => t.id === toggleTalentoId);

  if (!talento) return null;

  const isActivating = !talento.is_active;

  const handleConfirm = async () => {
    const result = await dispatch(toggleTalentoActiveThunk(toggleTalentoId));
    if (result.meta.requestStatus === "fulfilled") {
      // Recargar la lista después de cambiar el estado
      dispatch(getTalentosThunk({ page, search }));
    }
  };

  return (
    <Modal
      open={confirmModalOpen}
      onClose={() => dispatch(closeConfirmToggle())}
      title={isActivating ? "Activar talento" : "Desactivar talento"}
      size="sm"
    >
      <div className="text-center py-3">
        <Icon
          icon={
            isActivating
              ? "mdi:check-circle-outline"
              : "mdi:alert-circle-outline"
          }
          className={`icon text-64 mb-3 ${
            isActivating ? "text-success" : "text-warning"
          }`}
        />
        <p className="mb-4">
          ¿Está seguro que desea {isActivating ? "activar" : "desactivar"} el
          talento <strong>{talento.nombre}</strong>?
        </p>
        <div className="d-flex align-items-center justify-content-center gap-3">
          <button
            type="button"
            className="btn btn-outline-secondary px-20 py-11"
            onClick={() => dispatch(closeConfirmToggle())}
            disabled={toggling}
          >
            Cancelar
          </button>
          <button
            type="button"
            className={`btn ${
              isActivating ? "btn-success" : "btn-warning"
            } px-20 py-11`}
            onClick={handleConfirm}
            disabled={toggling}
          >
            {toggling ? "Procesando..." : "Confirmar"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmToggleModal;
